import React from "react";

export default function DeleteButton({ url, onClick, className, children }) {
    const onClickHandle = (e) => {
        if (onClick) {
            e.preventDefault();
            onClick();
        }
    };

    return (
      <button href={url} className={className} onClick={onClickHandle}>{children}</button>
    );
}

DeleteButton.propTypes = {
    className: React.PropTypes.string,
    onClick: React.PropTypes.func,
    url: React.PropTypes.string,
    children: React.PropTypes.node,
};

DeleteButton.defaultProps = {
    className: "icon remove",
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Atoms/DeleteButton.jsx